import { NextSeo } from "next-seo";
import PrivacyPolicy from "../components/PrivacyPolicy/PrivacyPolicy";

export default function NOMO() {
  return (
    <>
      <NextSeo title="Nomo" description="Terms and Conditions" />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginTop: "100px",
          marginBottom: "20px",
            paddingRight: "20px",
            paddingLeft: "20px"

        }}
      >
        <PrivacyPolicy />
      </div>
    </>
  );
}
